import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const UserIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 9 9" {...props}>
    <path d="M2.8125 2.4375C2.8125 3.36787 3.56962 4.125 4.5 4.125C5.43038 4.125 6.1875 3.36787 6.1875 2.4375C6.1875 1.50712 5.43038 0.75 4.5 0.75C3.56962 0.75 2.8125 1.50712 2.8125 2.4375ZM7.5 7.875H7.875V7.5C7.875 6.05287 6.69712 4.875 5.25 4.875H3.75C2.3025 4.875 1.125 6.05287 1.125 7.5V7.875H1.5H1.875H7.125H7.5Z" />
  </SvgIcon>
);
